import { localStorageService } from '@findy-code/yuffie/services/local-storage';

import type { UserRouteHistory } from './types';

export function getUserRouteHistory(): UserRouteHistory | null | undefined {
  const rh = localStorageService.getItem('routeHistory');
  try {
    return JSON.parse(typeof rh === 'string' ? rh : 'null');
  } catch {
    return;
  }
}
